import TaxiCorporationFleetPartnerAddParams from "../../../../../common/services/taxi-corporation/fleet-partner/add/taxi-corporation-fleet-partner-add-params";
import TaxiFleetPartnerAddFormData from "./types/taxi-fleet-partner-add-form-data";

const create = (
  formData: TaxiFleetPartnerAddFormData,
  taxiCorporationUuid: string,
): TaxiCorporationFleetPartnerAddParams => {
  return {
    name: formData.name,
    notes: formData.notes,
    taxiCorporationUuid,
  };
};

const taxiFleetPartnerAddParamsFactory = {
  create,
};

export default taxiFleetPartnerAddParamsFactory;
